import React from 'react';
import { Field } from './Field';
import { describedBy, inputClass } from '../../utils/styles';
type TextAreaFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  hint?: string;
  error?: string;
  placeholder?: string;
  maxLength?: number;
  className?: string;
};
export function TextAreaField({
  id,
  label,
  value,
  onChange,
  required = false,
  hint,
  error,
  placeholder,
  maxLength = 1500,
  className
}: TextAreaFieldProps) {
  return <Field id={id} label={label} required={required} hint={hint} error={error} className={className} data-id="element-88" data-mp="1p0i5226gpfh0">
      <textarea id={id} name={id} rows={5} value={value} maxLength={maxLength} placeholder={placeholder} onChange={e => onChange(e.target.value)} aria-required={required} aria-invalid={Boolean(error)} aria-describedby={describedBy(id, Boolean(hint), Boolean(error))} className={`${inputClass(Boolean(error))} resize-y`} data-id="element-89" data-mp="1b1icijftwgfk" />
      <p className="mt-1.5 text-right text-xs text-muted" aria-hidden="true" data-id="element-90" data-mp="2cev07sg6hi6k">
        {value.length} / {maxLength}
      </p>
    </Field>;
}